// extracted by mini-css-extract-plugin
module.exports = {"svg-icon":"icons-m__svg-icon__1amYr"};